import {
  APP_BAR_HEIGHT,
  APP_BAR_HEIGHT_TABLET,
  DRAWER_WIDTH_FULL,
  DRAWER_WIDTH_LG,
  MIBUILD_PAGE_HEADER_HEIGHT,
} from "@miplatform/constants";
import { useMediaQuery, useTheme } from "@mui/material";
import { DocumentPreview } from "../DocumentPreview/DocumentPreview";
import { MiContentDrawer } from "../MiContentDrawer/MiContentDrawer";

/* see HomeDetails.jsx for usage example */
export function DocumentPreviewDrawer({ selectedDocument = null, onClose }) {
  const theme = useTheme();
  const isMd = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const isLg = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  const DRAWER_TOP_OFFSET =
    (isMd ? APP_BAR_HEIGHT_TABLET : APP_BAR_HEIGHT) +
    MIBUILD_PAGE_HEADER_HEIGHT;

  const DRAWER_RIGHT_OFFSET = isLg ? DRAWER_WIDTH_LG : DRAWER_WIDTH_FULL;

  return (
    <MiContentDrawer
      variant="persistent"
      title={selectedDocument?.name || "Document Details"}
      open={!!selectedDocument}
      onClose={onClose}
      width={DRAWER_WIDTH_LG}
      slotProps={{
        transition: {
          unmountOnExit: true,
        },
      }}
      hideBackdrop
      removeMargin
      sx={{
        "& > .MuiPaper-root": {
          top: DRAWER_TOP_OFFSET,
          height: `calc(100% - ${DRAWER_TOP_OFFSET}px)`,
          right: DRAWER_RIGHT_OFFSET,
          zIndex: theme.zIndex.drawer - 1, // renders below HomeDocumentsDrawer
        },
      }}
    >
      <DocumentPreview selectedDocument={selectedDocument} />
    </MiContentDrawer>
  );
}
